export const FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_REQUEST =
  "FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_REQUEST";
export const FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_SUCCESS =
  "FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_SUCCESS";
export const FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_ERROR =
  "FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_ERROR";
